import type { ComponentType } from "react";
import TradingDashboardPage from "../dashboard/TradingDashboardPage";
import TradingJournalPage from "../trading-journal/TradingJournalPage";
import TradingAnalyticsPage from "../trading-journal/AnalyticsDashboard";
import PropFirmManagerPage from "../prop-firm-manager/PropFirmManagerPage";
import TradingAccountsPage from "../trading-accounts/TradingAccountsPage";
import AccountDetailPage from "../trading-accounts/AccountDetailPage";
import TradingSessionsPage from "../trading-sessions/TradingSessionsPage";
import SessionDetailPage from "../trading-sessions/SessionDetailPage";
import EdgyReportsPage from "../edgy/EdgyReportsPage";
import PlaybookPage from "../playbook/PlaybookPage";
import DisciplineManagerPage from "../discipline-manager/DisciplineManagerPage";
import ReportsPage from "../social-reports/ReportsPage";
import ReportDetailPage from "../social-reports/ReportDetailPage";
import { useUiMode } from "./mode/useUiMode";
import LiteDashboardPage from "./pages/LiteDashboardPage";
import LiteJournalPage from "./pages/LiteJournalPage";
import LiteStatsPage from "./pages/LiteStatsPage";
import LitePropFirmsPage from "./pages/LitePropFirmsPage";
import LiteAccountsPage from "./pages/LiteAccountsPage";
import LiteAccountDetailPage from "./pages/LiteAccountDetailPage";
import LiteSessionsPage from "./pages/LiteSessionsPage";
import LiteSessionDetailPage from "./pages/LiteSessionDetailPage";
import LiteEdgyPage from "./pages/LiteEdgyPage";
import LiteDisciplinePage from "./pages/LiteDisciplinePage";
import LiteReportsPage from "./pages/LiteReportsPage";
import LiteReportDetailPage from "./pages/LiteReportDetailPage";

// Aiguillage Lite / Advanced sur les routes communes : mêmes URLs, la page
// rendue dépend du mode effectif. Hors liste LITE_MODE_USERS = toujours la page Advanced.
// Rien n'est rendu tant que l'accès n'est pas connu (voir `ready`).

export function DashboardRoute(props: Record<string, unknown>) {
  const Advanced = TradingDashboardPage as ComponentType<Record<string, unknown>>;
  const ui = useUiMode();
  if (!ui.ready) return null;
  return ui.mode === "lite" ? <LiteDashboardPage /> : <Advanced {...props} />;
}
export function JournalRoute(props: Record<string, unknown>) {
  const Advanced = TradingJournalPage as ComponentType<Record<string, unknown>>;
  const ui = useUiMode();
  if (!ui.ready) return null;
  return ui.mode === "lite" ? <LiteJournalPage /> : <Advanced {...props} />;
}
export function AnalyticsRoute(props: Record<string, unknown>) {
  const Advanced = TradingAnalyticsPage as ComponentType<Record<string, unknown>>;
  const ui = useUiMode();
  if (!ui.ready) return null;
  return ui.mode === "lite" ? <LiteStatsPage /> : <Advanced {...props} />;
}
export function PropFirmManagerRoute(props: Record<string, unknown>) {
  const Advanced = PropFirmManagerPage as ComponentType<Record<string, unknown>>;
  const ui = useUiMode();
  if (!ui.ready) return null;
  return ui.mode === "lite" ? <LitePropFirmsPage /> : <Advanced {...props} />;
}
export function AccountsRoute(props: Record<string, unknown>) {
  const Advanced = TradingAccountsPage as ComponentType<Record<string, unknown>>;
  const ui = useUiMode();
  if (!ui.ready) return null;
  return ui.mode === "lite" ? <LiteAccountsPage /> : <Advanced {...props} />;
}
export function AccountDetailRoute(props: Record<string, unknown>) {
  const Advanced = AccountDetailPage as ComponentType<Record<string, unknown>>;
  const ui = useUiMode();
  if (!ui.ready) return null;
  return ui.mode === "lite" ? <LiteAccountDetailPage /> : <Advanced {...props} />;
}
export function TradingSessionsRoute(props: Record<string, unknown>) {
  const Advanced = TradingSessionsPage as ComponentType<Record<string, unknown>>;
  const ui = useUiMode();
  if (!ui.ready) return null;
  return ui.mode === "lite" ? <LiteSessionsPage /> : <Advanced {...props} />;
}
export function SessionDetailRoute(props: Record<string, unknown>) {
  const Advanced = SessionDetailPage as ComponentType<Record<string, unknown>>;
  const ui = useUiMode();
  if (!ui.ready) return null;
  return ui.mode === "lite" ? <LiteSessionDetailPage /> : <Advanced {...props} />;
}
// Le Lite réunit analyses EdgyAI et playbook sur une seule page, ouverte sur l'onglet de l'URL d'origine.
export function EdgyReportsRoute(props: Record<string, unknown>) {
  const Advanced = EdgyReportsPage as ComponentType<Record<string, unknown>>;
  const ui = useUiMode();
  if (!ui.ready) return null;
  return ui.mode === "lite" ? <LiteEdgyPage initialTab="analyses" /> : <Advanced {...props} />;
}
export function PlaybookRoute(props: Record<string, unknown>) {
  const Advanced = PlaybookPage as ComponentType<Record<string, unknown>>;
  const ui = useUiMode();
  if (!ui.ready) return null;
  return ui.mode === "lite" ? <LiteEdgyPage initialTab="playbook" /> : <Advanced {...props} />;
}
export function DisciplineRoute(props: Record<string, unknown>) {
  const Advanced = DisciplineManagerPage as ComponentType<Record<string, unknown>>;
  const ui = useUiMode();
  if (!ui.ready) return null;
  return ui.mode === "lite" ? <LiteDisciplinePage /> : <Advanced {...props} />;
}
// Rapports : le Lite ne garde que le bilan chiffré (pas de visuel pour les réseaux sociaux).
export function ReportsRoute(props: Record<string, unknown>) {
  const Advanced = ReportsPage as ComponentType<Record<string, unknown>>;
  const ui = useUiMode();
  if (!ui.ready) return null;
  return ui.mode === "lite" ? <LiteReportsPage /> : <Advanced {...props} />;
}
export function ReportDetailRoute(props: Record<string, unknown>) {
  const Advanced = ReportDetailPage as ComponentType<Record<string, unknown>>;
  const ui = useUiMode();
  if (!ui.ready) return null;
  return ui.mode === "lite" ? <LiteReportDetailPage /> : <Advanced {...props} />;
}
